import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const committeeMembershipApi = generateNomenApi(`/committee/committee-membership`);

export const committeeMembershipOptions = generateNomenOptions('committee-membership', committeeMembershipApi);
